import { Box } from '@mui/material';
import { useLabTests } from '@hc/store/backoffice/masters/labTests';
import PropTypes from 'prop-types';
import { Button, Drawer, Input, Label } from '@hc/ui/atoms';
import { labTestsDrawer_style } from './style';

function LabTestsDrawer(props) {
  const {
    drawerOpen = false,
    closeMasterDrawer = () => false,
    upsertMaster = () => {},
  } = props;

  const { handleChange, lab_test, lab_test_id } = useLabTests((state) => ({
    handleChange: state.handleChange,
    lab_test: state.lab_test,
    lab_test_id: state.lab_test_id,
  }));

  return (
    <Box>
      {drawerOpen && (
        <Drawer
          show={drawerOpen}
          onCloseDrawer={closeMasterDrawer}
          anchor="right"
          isCloseIconRequired
          header={`${lab_test_id ? 'Update' : 'Add'} lab Tests`}
          headerStyle={labTestsDrawer_style.drawerHeadSx}
          footerStyle={{ borderTop: '0px', py: 2.8, px: 2 }}
          footer={
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                buttonStyle={labTestsDrawer_style.saveBtnSx}
                onClick={upsertMaster}
              >
                {lab_test_id ? 'Update' : 'Add'}
              </Button>
              <Button
                buttonStyle={labTestsDrawer_style.cancleBtnSx}
                onClick={closeMasterDrawer}
              >
                Cancel
              </Button>
            </Box>
          }
        >
          <Box sx={labTestsDrawer_style.boxRootSx}>
            <Box sx={labTestsDrawer_style.inputGroupSx}>
              <Label
                rootStyle={labTestsDrawer_style.labelSx}
                htmlFor="labTests"
                isRequired
              >
                lab Tests
              </Label>
              <Input
                id="labTests"
                textFieldStyle={labTestsDrawer_style.inputFieldSx}
                onChange={(e) => handleChange(e.target.value)}
                fullWidth
                value={lab_test}
              />
            </Box>
          </Box>
        </Drawer>
      )}
    </Box>
  );
}

LabTestsDrawer.propTypes = {
  drawerOpen: PropTypes.bool,
  closeMasterDrawer: PropTypes.func,
};

export { LabTestsDrawer };
